module.exports = __webpack_public_path__ + "static/vespignani-97128997f56b73f9080d1eb028d328d7.jpg";